// extracted by mini-css-extract-plugin
export default {"input":"InputCheckbox_input__Eb3rZ"};